// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.$http = axios;
Vue.prototype.$api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* 重置样式 */
import './assets/css/reset.min.css'

/* 通用样式 */
import './assets/css/public.css'

/* animate.css */
import 'animate.css'
 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)

/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = '小金星国际教育集团-' + to.meta.title
    }
    localStorage.setItem('curNav',to.path)
    if(to.name == 'about'){
      if(to.query.source){
        

        // console.log(111111111,to.query.source)
        // let targetId = document.getElementById(to.query.source);
        // console.log(targetId.scrollTop());
        // document.body.scrollTo = targetId.offsetTop
        // let current =  $("#project").scrollTop();
        // $("html,body").stop().animate({
        //   screenTop: current
        // })
        // Vue.$nextTicket(()=>{
        //   let toElement = document.getElementById('project')
        //   toElement.scrollIntoView()
        // })
      }else{
        // window.scroll(0,0)
      }
    }else{
      // window.scroll(0,0)
    }
    next();
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js